import React from 'react';
import P from 'prop-types';
import * as Styled from './ConfirmDelete.styles.js';

import { translate as t } from '@utils/translate';

const ConfirmDelete = ({ onCancel, onConfirm, loading, currentLabel }) => {
  const TEXTS = {
    CONFIRM_DELETE: t('deleteCreditCardConfirm'),
    DELETE: t('delete'),
    BACK: t('back'),
  };

  return (
    <Styled.Container>
      <Styled.Info>{TEXTS.CONFIRM_DELETE}</Styled.Info>
      <Styled.Flex>
        <Styled.Button onClick={onConfirm} loading={loading}>
          {currentLabel}
        </Styled.Button>
        {!loading && (
          <Styled.Button onClick={onCancel} secondary>
            {TEXTS.BACK}
          </Styled.Button>
        )}
      </Styled.Flex>
    </Styled.Container>
  );
};

ConfirmDelete.propTypes = {
  onCancel: P.func,
  onConfirm: P.func,
  loading: P.bool,
  currentLabel: P.string,
};

export default ConfirmDelete;
